import {
  PARTNER_ACTIVE_CASE_STEPS,
  type DefineRule,
  type RuleConditions,
} from "./ability-rule-conditions";

/** A Customer only identifies the case; analysis fills every other field from their documents. */
const CUSTOMER_CASE_CREATE_FIELDS = ["id", "clientId", "branchId", "caseType", "externalCode"];

export const defineCustomerRules = (
  can: DefineRule,
  conditions: RuleConditions,
  clientIds: readonly string[] = [],
) => {
  for (const claimScope of conditions.claimScopes) {
    can("create", "Case", CUSTOMER_CASE_CREATE_FIELDS, claimScope);
    can("read", "Case", claimScope);
    can("create", "Document", { ...claimScope, caseId: { $ne: null } });
    can(["read", "readAnalysis"], "Document", {
      ...claimScope,
      caseId: { $ne: null },
      visibleTo: "Customer",
    });
    can(["read", "readAnalysis"], "Document", {
      ...claimScope,
      caseId: { $ne: null },
      ...conditions.ownDocument,
    });
  }
  can(["analyze", "delete"], "Case", { ...conditions.ownCase, step: "creation" });
  can("finishOthersDraft", "Case", conditions.ownCase);
  can("finishOthersDraft", "Case", conditions.openCreationReview);
  can("read", "Client", { id: { $in: [...clientIds] } });
  can(
    ["read", "update", "execute", "createReminder", "updateReminder", "removeReminder"],
    "Task",
    conditions.assignedTask,
  );
  can("update", "Profile");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};

export const definePartnerRules = (can: DefineRule, conditions: RuleConditions) => {
  for (const claimScope of conditions.claimScopes) {
    can("read", "Case", {
      ...claimScope,
      step: { $in: [...PARTNER_ACTIVE_CASE_STEPS] },
    });
  }
  can(
    ["read", "update", "execute", "createReminder", "updateReminder", "removeReminder"],
    "Task",
    conditions.assignedTask,
  );
  can("update", "Profile");
  can("read", "Calendar");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};

export const defineExpertRules = (can: DefineRule, conditions: RuleConditions) => {
  can(
    ["read", "update", "execute", "createReminder", "updateReminder", "removeReminder"],
    "Task",
    conditions.assignedTask,
  );
  can("update", "Profile");
  can("read", "Calendar");
  can(["read", "update"], "Notification");
  can(["read", "update"], "UserPreferences");
};
